import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
// import { intersection, keyBy, pick, sortBy } from 'lodash';

import { OrganizationSetting, SettingsSlice } from '../../../types';
import * as thunks from './thunk';

export type PropagationPreference = {
  propagateToAll: boolean;
};

export const settingsSlice = createSlice({
  name: 'orgSettings',
  initialState: {
    settings: {},
    validationError: null,
    propagationPreference: null as PropagationPreference | null,
  } as SettingsSlice,
  reducers: {
    updateSettings: (state, action: PayloadAction<OrganizationSetting>) => {
      const { authType } = action.payload;
      if (authType === 'saml' || authType === 'native') {
        action.payload.orgLoginWorkflow = 'Username & Password';
      }
      if (authType !== 'saml' && authType !== 'native') {
        state.settings.orgLoginWorkflow = state.settings.serverOrgLoginWorkflow;
      }
      state.settings = {
        ...state.settings,
        ...action.payload,
      };
    },
    setPropagationPreference: (state, action: PayloadAction<PropagationPreference>) => {
      state.propagationPreference = action.payload;
    },
    clearPropagationPreference: (state) => {
      state.propagationPreference = null;
    },
    setValidationError: (state, action: PayloadAction<string>) => {
      state.validationError = action.payload;
    },
    clearValidationError: (state) => {
      state.validationError = null;
    },
  },
});

export const settingsThunks = thunks;
